const TWO_FACTOR_UNVERIFIED_ERROR_CODE = 'TWO_FACTOR_UNVERIFIED';
const TWO_FACTOR_EXPIRED_ERROR_CODE = 'TWO_FACTOR_EXPIRED';

export {
    TWO_FACTOR_EXPIRED_ERROR_CODE,
    TWO_FACTOR_UNVERIFIED_ERROR_CODE,
};